import { useQueryClient } from "react-query";
import useAuthenticatedQuery from "../../useAuthenticatedQuery";
import attributeKeys from "./attributeKeys";
import fetchAttributesHandler from "./handlers/fetchAttributesHandler";

const useGetAttributes = () => {
  const queryClient = useQueryClient();

  const authenticatedResponse = useAuthenticatedQuery({
    queryKey: attributeKeys.attributes,
    queryFn: ({ signal }) => fetchAttributesHandler(signal),
    onError: (error) => {
      console.error("Error fetching Attributes", error);
    },
  });

  const refetchAttributes = async () => {
    await queryClient.invalidateQueries(attributeKeys.attributes);
  };

  const prefetchAttributes = async ({ signal }) => {
    await queryClient.prefetchQuery(
      attributeKeys.attributes,
      fetchAttributesHandler({ signal })
    );
  };

  const {
    data: attributes,
    isLoading: attributesLoading,
    isError: isAttributesError,
    error: attributesError,
    isFetched: attributesFetched,
  } = authenticatedResponse;

  return {
    refetchAttributes,
    attributes,
    prefetchAttributes,
    attributesLoading,
    isAttributesError,
    attributesError,
    attributesFetched,
  };
};

export default useGetAttributes;
